import {axiosGetHandler, axiosPostHandler} from '../config'
import {extractAPIValues} from '_lib/utils/utils'
const { BASE_API, BASE_XHH } = extractAPIValues()

// 获取帖子详情
export function getPostPageData (args) {
	let url = BASE_XHH + '/bbs/web/link/list'
	return axiosGetHandler(url, args)
}

// 获取游戏卡片数据(多个)
export function getGameCardsData (args) {
  let url = BASE_XHH + '/game/get_game_infos/'
  return axiosGetHandler(url, args)
}

// 获取商品卡片数据(多个)
export function getSkuCardsData (args) {
  let url = BASE_XHH + '/mall/sku/detail/'
  return axiosGetHandler(url, args)
}

// 获取百科卡片数据(多个)
export function getWikiCardsData (args) {
  let url = BASE_XHH + '/wiki/get_wiki_infos'
  return axiosGetHandler(url, args)
}

// 获取联赛卡片数据(多个)
export function getLeagueCardsData (args) {
  let url = BASE_XHH + '/game/match/leagues'
  return axiosGetHandler(url, args)
}

// 获取赛事卡片数据(多个)
export function getMatchCardsData (args) {
  let url = BASE_XHH + '/game/match/batch_match_data'
  return axiosGetHandler(url, args)
}

// 获取游戏单卡片数据(多个)
export function getAlbumCardsData (args, formatData) {
  let url = BASE_XHH + '/game/self_made_game_list/data/infos'
  return axiosPostHandler(url, args, formatData)
}

// 获取dota比赛战报卡片数据(单个)
const dota2_match_record = {}
export function getDota2MatchRecordCardsData (args) {
  if (!(args.match_id in dota2_match_record)) {
    let url = BASE_XHH + '/game/dota2/timeline/news_data'
    dota2_match_record[args.match_id] = axiosGetHandler(url, args)
  }
  return dota2_match_record[args.match_id]
}

// 获取dota比赛战报卡片数据(单个)
const lol_match_record = {}
export function getLOLMatchRecordCardsData (args) {
  if (!(args.match_id in lol_match_record)) {
    let url = BASE_XHH + '/game/lol/match/game/data'
    lol_match_record[args.match_id] = axiosGetHandler(url, args)
  }
  return lol_match_record[args.match_id]
}


// 提交投票
export function submitVoteResult (args, formatData) {
  let url = BASE_XHH + '/bbs/app/link/vote'
  return axiosPostHandler(url, args, formatData)
}

// 发奖表格数据获取
export function getAwardTableCardData (args) {
  var url = BASE_XHH + '/bbs/app/api/article/get_award_users'
  return axiosGetHandler(url, args)
}

// 发奖表格数据获取
export function getChatRoomCardData (args) {
  var url = BASE_XHH + '/chatroom/v2/room/card_info'
  return axiosGetHandler(url, args)
}

// 获取帖子详情
export function getLinkDetail (args) {
  var url = BASE_XHH + '/bbs/app/link/web/view'
  return axiosGetHandler(url, args)
}

// 获取评论列表
export function getLinkCommentList (args) {
  let url = BASE_XHH + '/bbs/app/link/tree'
  return axiosGetHandler(url, args)
}

// 获取子评论列表
export function getSubCommentList (args) {
  let url = BASE_XHH + '/bbs/app/comment/sub/comments'
  return axiosGetHandler(url, args)
}

// 评论点赞
export function supportComment (args, formdata) {
  let url = BASE_XHH + '/bbs/app/comment/support'
  return axiosPostHandler(url, args, formdata)
}

// 删除评论
export function deleteComment (args, formdata) {
  let url = BASE_XHH + '/bbs/app/comment/delete'
  return axiosPostHandler(url, args, formdata)
}

// 删除帖子
export function deleteLink (args, formdata) {
  let url = BASE_XHH + '/bbs/app/link/delete'
  return axiosPostHandler(url, args, formdata)
}

export function upGameComment (args, formdata) {
  let url = BASE_XHH + '/bbs/app/link/game/comment/up'
  return axiosPostHandler(url, args, formdata)
}